import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Row } from 'react-bootstrap'
import BtnBack from '../../../../btn-back'
import TableSoftware from './table-software'
import TableAssets from './table-assets'
import {
  getPropertyAssetAPI,
  getPropertyLicensesAPI
} from '../../../../../services/property'

import { BsPlusLg } from 'react-icons/bs'
import AddAssetsTable from './add-table-assets'
import { useSelector } from 'react-redux'

function PropertyInfoASS({ data }) {
  const [orgData, setOrgData] = useState([])
  const [orgDatas, setOrgDatas] = useState([])
  const { profile: profileDetail } = useSelector(
    (state) => state.profileReducer
  )

  const orgId = profileDetail?.orgId
  const code = profileDetail?.code

  const [showAdd, setShowAdd] = useState(false)
  const [isSave, setIsSave] = useState(false)
  const [isRefresh, setIsRefresh] = useState(false)
  const [dataTable, setdataTable] = useState(false)

  useEffect(() => {
    async function getData() {
      const AllData = await getPropertyAssetAPI({ orgId, code })

      if (!AllData) return
      setOrgData(AllData.result)
    }

    if (orgId && code) {
      getData()
    }
    return () => {}
  }, [orgId, code, isRefresh])

  useEffect(() => {
    async function getDatas() {
      const AllDatas = await getPropertyLicensesAPI({ orgId, code })

      if (!AllDatas) return
      setOrgDatas(AllDatas.result)
    }

    if (orgId && code) {
      getDatas()
    }
    return () => {}
  }, [orgId, code])

  useEffect(() => {
    getAssets()
    setIsRefresh(false)
  }, [isRefresh])

  const getAssets = async () => {
    const result = await getPropertyAssetAPI(data)

    if (!result) return
    if (result.status) {
      setdataTable(result.result)
    }
  }

  const toggleButton = () => {
    setdataTable(!dataTable)
  }

  return (
    <div>
      <Card className="overflow-auto border-0">
        <Card.Body>
          <BtnBack text={'Assets'} />
          <Row>
            <Col xs={12}>
              {orgData && orgDatas.length === 0 && (
                <Button
                  className="px-4 btn btn-primary me-3"
                  style={{ float: 'right' }}
                  onClick={() => setShowAdd(true)}
                >
                  <BsPlusLg /> Add Assets
                </Button>
              )}

              <TableAssets data={orgData} datas={orgDatas} />

              <TableSoftware datas={orgDatas} />
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {showAdd && (
        <AddAssetsTable
          data={{ orgId, code }}
          setIsSave={setIsSave}
          showAdd={showAdd}
          isSave={isSave}
          fnGetData={getAssets}
          setShowAdd={setShowAdd}
          onChange={toggleButton}
          setIsRefresh={setIsRefresh}
          isRefresh={isRefresh}

          // onChange={handleInputChange}
        />
      )}
    </div>
  )
}

export default PropertyInfoASS
